// Number parsing + formatting helpers used by the local sum-only shortcut
// in useReveal (skipped when multi-question mode is on).

/**
 * Parse all whole numbers from text and sum them.
 * Ignores commas/periods used as thousand separators by stripping them when
 * inside a number sequence, and treats a single period as a decimal.
 * Returns { numbers: number[], total: number } or null if none found.
 */
export function sumNumbersInText(text) {
  if (!text) return null;
  // Match sequences of digits (with optional thousands separators) and optional decimal.
  // Allow comma or period as thousands separator; final '.' followed by digits is decimal.
  const pattern = /-?\d{1,3}(?:[ ,.\u202F]\d{3})+(?:\.\d+)?|-?\d+(?:\.\d+)?/g;
  const matches = text.match(pattern) || [];
  const numbers = matches
    .map((m) => {
      // Strip thousands separators (spaces/commas) but keep last '.' as decimal
      // if it's followed by 1-2 digits at the end.
      const lastDot = m.lastIndexOf(".");
      const isDecimal =
        lastDot !== -1 && m.length - lastDot - 1 >= 1 && m.length - lastDot - 1 <= 3 &&
        !/[ ,]/.test(m.slice(lastDot));
      let cleaned;
      if (isDecimal) {
        cleaned = m.slice(0, lastDot).replace(/[ ,.\u202F]/g, "") + "." + m.slice(lastDot + 1);
      } else {
        cleaned = m.replace(/[ ,.\u202F]/g, "");
      }
      const n = Number(cleaned);
      return Number.isFinite(n) ? n : null;
    })
    .filter((n) => n !== null);
  if (!numbers.length) return null;
  const total = numbers.reduce((a, b) => a + b, 0);
  return { numbers, total };
}

export function formatNumber(n) {
  if (typeof n !== "number" || !Number.isFinite(n)) return String(n);
  // Avoid weird floating noise like 80235.00000001
  const rounded = Math.round(n * 1e6) / 1e6;
  return rounded.toLocaleString(undefined, { maximumFractionDigits: 6 });
}
